// extracted by mini-css-extract-plugin
module.exports = {"Artwork":"Artwork_Artwork__22qYx","BigCard":"Artwork_BigCard__2VzcD","MediumCard":"Artwork_MediumCard__1IcV3","SmallCard":"Artwork_SmallCard__1wTn4"};